import { Drawer, Button, Card, Row, Col } from "antd";
import Icon from "@ant-design/icons";
import { ToteIcon, PriorityIcon } from "../../assets/icons/icons";
import { useToteById, useTrolleyById } from "../../pages/common/queries";
import "./ConfirmationModal.scss";
import Styles from "../../pages/operator/op.module.scss";
import { getTrolleyStatus } from "../reusable/styles";
import { convertUTCToLocal } from "../../utils/timeUtils";

interface UnloadToteConfirmationModalProps {
  open: boolean;
  toteId: string;
  trolleyId?: string;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
}

const UnloadToteConfirmationModal = ({
  open,
  toteId,
  trolleyId,
  onConfirm,
  onCancel,
  isLoading = false,
}: UnloadToteConfirmationModalProps) => {
  const { data: toteData } = useToteById(toteId);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { data: trolleyData } = useTrolleyById(
    trolleyId && open ? trolleyId : undefined
  );

  return (
    <Drawer
      open={open}
      onClose={onCancel}
      className="confirmation-drawer unload-tote-modal"
      placement="bottom"
      closable={false}
      mask={true}
      height="auto"
      destroyOnClose
    >
      <div className="confirmation-content">
        <h2 className="confirmation-title">Unload Tote</h2>
        <p className="confirmation-subtitle">
          Do you want to unload this tote from the trolley?
        </p>

        {toteData && (
          <>
            <Card style={{ marginBottom: "20px" }}>
              <Row justify="space-between">
                <Row gutter={15}>
                  <Col
                    className={Styles.iconBox}
                    style={{ background: "#e6f3f7" }}
                  >
                    <Icon component={ToteIcon} />
                  </Col>
                  <Col>
                    <div className="labels">Tote No</div>
                    <div className="values">{toteData?.toteNo}</div>
                  </Col>
                </Row>
                <Row gutter={15} align="middle">
                  {toteData?.priority && (
                    <Col
                      className={Styles.iconBox}
                      style={{ background: "#FFEBEA" }}
                    >
                      <Icon component={PriorityIcon} />
                    </Col>
                  )}
                </Row>
              </Row>

              <div className="info-details-grid" style={{ marginTop: "10px" }}>
                {/* <div className="info-item">
                  <div className="labels">Weight</div>
                  <div className="info-value-small">{toteData.weight}</div>
                </div>
                <div className="info-item">
                  <div className="labels">Item count</div>
                  <div className="info-value-small">
                    {toteData.itemCount || "0"}
                  </div>
                </div> */}
                <div className="info-item">
                  <div className="labels">MSN</div>
                  <div className="info-value-small">{toteData.msn}</div>
                </div>
                <div className="info-item">
                  <div className="labels">USM</div>
                  <div className="info-value-small">
                    {toteData.usn || toteData?.usm}
                  </div>
                </div>
                <div className="info-item">
                  <div className="labels">Status</div>
                  <div
                    style={{
                      color: getTrolleyStatus(toteData.activityStatus),
                      fontWeight: 600,
                    }}
                  >
                    {toteData.activityStatus}
                  </div>
                </div>
                <div className="info-item">
                  <div className="labels">Registered Date</div>
                  <div className="info-value-small">
                    {convertUTCToLocal(toteData.registeredDate) || "N/A"}
                  </div>
                </div>
              </div>

              {/* <div className="info-divider"></div>

              <div className="info-single-row">
                <div className="info-label">Last Scanned Location</div>
                <div className="info-value-dark">
                  {toteData.lastScannedLocation || "N/A"}
                </div>
              </div> */}

              <div className="info-details-grid bottom-grid"></div>
            </Card>
          </>
        )}

        {/* {trolleyData && (
          <>
            <div className="info-section-label">Trolley Info</div>
            <div className="info-card single-card">
              <div className="info-header">
                <div className="info-row">
                  <Icon component={TrolleyIcon} className="info-icon" />
                  <div>
                    <div className="info-label">Trolley ID</div>
                    <div className="info-value">{trolleyData.id}</div>
                  </div>
                </div>
              </div>

              <div className="info-single-item">
                <div className="info-label">Status</div>
                <div
                  className="info-value-small status-loading"
                  style={{ color: getTrolleyStatus(trolleyData.status) }}
                >
                  {trolleyData.status}
                </div>
              </div>

              <div className="info-divider"></div>

              <div className="info-single-row">
                <div className="info-label">Last Scanned Location</div>
                <div className="info-value-dark">
                  {trolleyData.lastScannedLocation || "N/A"}
                </div>
              </div>
            </div>
          </>
        )} */}

        <div className="modal-actions">
          <Button
            onClick={onCancel}
            className="cancel-button"
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            className="confirm-button"
            loading={isLoading}
            disabled={isLoading}
          >
            Confirm Unload
          </Button>
        </div>
      </div>
    </Drawer>
  );
};

export default UnloadToteConfirmationModal;
